import { isEditableField, isContainer, isWidget, fieldTypes } from "../../MPP-Common-SPA/common/form/fieldTypes";
import { 
  canadaAddressSchema,
  phoneMobileSchema, 
  firstNationStatusDetailSchema, 
  familyMembersSchema, 
  dateOfBirthSchema, 
  mapLocationSchema, 
  bankDetailsSchema } from "../../MPP-Common-SPA/common/constants/schemas"; 
import { evaluate } from "../../MPP-Common-SPA/utils/globalUtility";

const filterDataByVisibleElements = (data, fields, context, getRefData) => {
  const visibleFields = checkVisibleFields(data, fields, context, getRefData);
      
  // Compare whats visible to the application data, and remove app data that shouldn't be there.
  const filteredData = data ? Object.fromEntries(
    Object.entries(data).filter(([key, values]) => visibleFields.includes(key) || typeof values === 'object')
  ) : {};

  return filteredData;
}

const checkVisibleFields = (data, fields, context, getRefData) => {
    // Create expression context based on context. Follows similar flow to Dynamic forms/fields.
    
    const visibleFields = [];
    (fields ?? []).forEach((field) => {

      if (!!field.condition?.stepName && context.getStepData) {
        const stepData = context.getStepData(field.condition.stepName);
        context[field.condition.stepName] = stepData;
      }
      if (!!field.condition?.category) {
        context[field.condition?.category] = getRefData({category: field.condition?.category});
      }
    
      const expressionValue = evaluate(field.condition, context, data || {});

      if (expressionValue === true) {
        if (field.condition?.action === 'hidden') {
          // Field is hidden
          return;
        }
      }
      
      // Enumerate values for field.
      if (isContainer(field.type)) {
        const childFields = checkVisibleFields(data, field.fields, context, getRefData);
        visibleFields.push(...childFields); // Merge child results
      }
      if (!isWidget(field.type) && isEditableField(field.type)) {
        const { name, extraName } = field.properties;
        visibleFields.push(name);
        extraName && visibleFields.push(extraName);
      }
      if (field.type === fieldTypes.value) {
        if (field.properties.method === 'getRefValue') {
          const { name, extraName } = field.properties;
          visibleFields.push(name);
          extraName && visibleFields.push(extraName);
        } else {
          Object.keys(field.properties.params ?? []).forEach(name => {
            visibleFields.push(name);    
          });
        }
      }
      if (field.type === fieldTypes.dateWidget) {
        // Names for date widget
        visibleFields.push(...(Object.keys(dateOfBirthSchema.fields)));
      }
      if (field.type === fieldTypes.phoneWidget) {
        // Names for phone widget
        visibleFields.push(...(Object.keys(phoneMobileSchema.fields)));
      }
      if (field.type === fieldTypes.addressWidget) {
        // Names for address widget
        visibleFields.push(...(Object.keys(canadaAddressSchema.fields)));
      }
      if (field.type === fieldTypes.firstNationStatusWidget) {
        // Names for firstNationStatus widget
        visibleFields.push(...(Object.keys(firstNationStatusDetailSchema.fields)));
      }
      if (field.type === fieldTypes.familyMembersWidget) {
        // Names for familyMembers widget
        visibleFields.push(...(Object.keys(familyMembersSchema.fields)));
      }
      if (field.type === fieldTypes.mapLocationWidget) {
        // Names for mapLocation widget
        visibleFields.push(...(Object.keys(mapLocationSchema.fields)));
      }
      if (field.type === fieldTypes.bankDetailsWidget) {
        // Names for bankDetails widget
        visibleFields.push(...(Object.keys(bankDetailsSchema.fields)));
      }
    })
    return visibleFields;
  };
  
const applicationUtils = {
  filterDataByVisibleElements
};

export default applicationUtils;
